import "./News.scss";
import { languageElements } from "./News-languageElements";
import LanguageElementsHandler from "../../repository/languageElementsHandler/LanguageElementsHandler";
import useMain from "../../common/MainContext";

export default function News(props) {
  const { language } = useMain();
  const languageElementsHandler = new LanguageElementsHandler(languageElements, language);

  return (
    <div className="news">
      <div className="news-greeting">
        <h1>{languageElementsHandler.get('news-greeting-title')}</h1>
        <p>{languageElementsHandler.get('news-greeting-p01')}</p>
        <p>{languageElementsHandler.get('news-greeting-p02')}</p>
      </div>
    </div>
  );
}
